<select [ngModel]="selectedLanguageCode" (ngModelChange)="onSelectLanguageCode($event)" id="type" name="type" class="form-control language-picker">
  <option [value]="lang.code" *ngFor="let lang of languages">
    {{ lang.name }}
  </option>
</select>
